import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { css } from "emotion";

const defaultStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface Props {}

const Spinner: React.FC<Props> = () => {
  return (
    <div className={defaultStyle}>
      <CircularProgress />
    </div>
  );
};

export default Spinner;
